// removed by extract-text-webpack-plugin
module.exports = {"content":"Subscribing__content--2Bx9n","text":"Subscribing__text--3v_Px","input":"Subscribing__input--2lNvH","subscribe":"Subscribing__subscribe--1BHsi","bounce":"Subscribing__bounce--2bngw"};


//////////////////
// WEBPACK FOOTER
// ./src/author/components/Subscribing/Subscribing.css
// module id = ./src/author/components/Subscribing/Subscribing.css
// module chunks = 2